// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-collect-day[data-v-e2af9c94] {\n  display: grid;\n  gap: 1.5rem/* 24px */;\n}\n.wrapper-filters[data-v-e2af9c94]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0.5rem; /* 16px */\n}\n.flex-1[data-v-e2af9c94] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.errorMessage[data-v-e2af9c94] {\n}\n", ""]);
// Exports
module.exports = exports;
